import { render, staticRenderFns } from "./EditarCodigo.vue?vue&type=template&id=0221e1d3&scoped=true&"
import script from "./EditarCodigo.vue?vue&type=script&lang=js&"
export * from "./EditarCodigo.vue?vue&type=script&lang=js&"
import style0 from "./EditarCodigo.vue?vue&type=style&index=0&id=0221e1d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0221e1d3",
  null
  
)

export default component.exports